<script setup>
const localePath = useLocaleRoute()
</script>

<template>
  <div class="pagination-container">
    <!-- Step Back -->
    <NuxtLink v-if="currentPage !== 1" :to="localePath('/blog/page/' + prevPage)"> &laquo; </NuxtLink>

    <!-- Page Numbers -->
    <NuxtLink
      v-for="n in totalPages"
      :key="n"
      :class="{ active: n === currentPage }"
      :to="localePath('/blog/page/' + n)"
    >
      {{ n }}
    </NuxtLink>

    <!-- Step Forward -->
    <NuxtLink v-if="currentPage !== totalPages" :to="localePath('/blog/page/' + nextPage)"> &raquo; </NuxtLink>
  </div>
</template>

<script>
export default {
  props: {
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  computed: {
    prevPage() {
      return this.currentPage > 0 ? this.currentPage - 1 : 0
    },
    nextPage() {
      return this.currentPage < this.totalPages ? this.currentPage + 1 : this.totalPages
    },
  },
}
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  list-style: none;
}

.pagination-container a {
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  font-size: 1.2rem;
}
.pagination-container a.active {
  text-decoration: underline;
}

.pagination-container a:hover {
  background-color: #329ad0;
  color: white;
}

.pagination-container .pagination-list li:hover:deep(a) {
  color: white;
}
</style>
